import { ArrowDown, ArrowUpRight } from 'lucide-react'
import { type ReactNode } from 'react'
import type { SiteCopy } from '../../content'
import { Button } from '../ui/button'
type HeroBlockProps = {
  copy: SiteCopy['hero']
  preview: ReactNode
  onPrimaryClick?: () => void
}

export function HeroBlock({ copy, preview, onPrimaryClick }: HeroBlockProps) {
  return <section className="hero" data-od-id="hero-section">
    <div className="container hero-grid">
      <div className="hero-copy">
        <p className="eyebrow">{copy.eyebrow}</p>
        <h1><span className="hero-title-motion">{copy.title}</span></h1>
        <p className="lead">{copy.lead}</p>
        <div className="hero-actions">
          <Button asChild><a href="#contact" onClick={onPrimaryClick}>{copy.primary}<ArrowUpRight aria-hidden="true" /></a></Button>
          <a className="text-link" href="#process">{copy.secondary}<ArrowDown aria-hidden="true" /></a>
        </div>
        <p className="hero-note">{copy.note}</p>
      </div>
      <div className="hero-stage" aria-label={copy.sceneLabel}>{preview}</div>
    </div>
  </section>
}
